export default __webpack_public_path__ + "static/media/Resume_Liz_Kane.eecf3116.pdf";